module.exports = __webpack_public_path__ + "static/media/QSAcess.f94aa24a.PNG";